<template>
  <div class="margin-top-10 h-100">
    <div>
      <div class="text-left margin-bottom-10">区域：</div>
<!--      <divider name="区域"></divider>-->
      <div class="text-left">
        <el-button @touchstart="() => operateArea({},'addArea')"  @click="() => operateArea({},'addArea')"
                   icon="el-icon-circle-plus-outline"
                   size="mini" type="primary">
          新增
        </el-button>
        <el-table
          :data="areaList"
          class="table no-row-border"
           size="mini"
          style="width: 100%;margin-top: 10px;">
          <el-table-column
            align="center"
            label="区域ID"
            prop="id">
          </el-table-column>
          <el-table-column
            align="center"
            label="区域名称"
            prop="name">
            <template slot-scope="scope">
              <el-input v-if="scope.row.edit" size="mini" v-model="scope.row.name"></el-input>
              <span v-else>{{ scope.row.name }}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center">
            <template slot-scope="scope">
              <span class="pointer text-red margin-left-10" @touchstart="deleteArea(scope.row)" @click="deleteArea(scope.row)">
                <i class="el-icon-delete" style="margin-right: 5px"></i>删除
              </span>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <div class="text-left margin-top-30">
      <div class="text-left margin-bottom-10">部门：</div>
      <el-button @touchstart="() => operateArea({},'add')" @click="() => operateArea({},'add')"
                 icon="el-icon-circle-plus-outline"
                 size="mini" type="primary" v-if="sectionTree.length<=0">
        新增
      </el-button>
      <el-tree
        :data="sectionTree"
        node-key="id"
        default-expand-all
        :expand-on-click-node="false">
      <span class="custom-tree-node" slot-scope="{ node, data }">
        <span style="">{{ data.name }}</span>
        <span class="margin-left-10">
          <el-button
            type="text"
            size="mini"
            @touchstart="() => operateArea(data,'add')"
            @click="() => operateArea(data,'add')">
            新增
          </el-button>
          <el-button
            type="text"
            size="mini"
            @touchstart="() => operateArea(data,'edit')"
            @click="() => operateArea(data,'edit')">
            编辑
          </el-button>
          <el-button
            v-if="data.parent !== 0"
            type="text"
            size="mini"
            @touchstart="() => deleteSection(node, data)"
            @click="() => deleteSection(node, data)">
            <span class="text-red">删除</span>
          </el-button>
        </span>
      </span>
      </el-tree>
    </div>
  </div>
</template>

<script>
export default {
  name: "Area",
  props: ['areaList', 'sectionList'],
  data() {
    return {
      sectionTree: [],
    }
  },
  watch: {
    sectionList() {
      this.initTree()
    }
  },
  mounted() {
    this.initTree()
  },
  methods: {
    initTree() {
      if (this.sectionList.length) {
       this.sectionTree = this.getTree(this.sectionList)
      }
    },
    operateArea(data,operate) {
      let title;
      let command;
      let params = {};
      let message;
      if (operate === 'add'){
        title = '新增部门'
        command = 'addSection'
        params.parent = data.id?data.id:0
        if(data.name){
          message = "请输入"+data.name+"子级部门名称"
        }else{
          message = "请输入部门名称"
        }
      }else if (operate === 'edit'){
        title = '编辑部门'
        command = 'alterSection'
        params = data
        message = "请输入"+data.name+"的新名称"
      }else if (operate === 'addArea'){
        title = '新增区域'
        command = 'addArea'
        message = "请输入区域名称"
      }
      this.$prompt(message, title, {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
      }).then(({value}) => {
        if (value.trim() === ""){
          this.$message.error("名称不能为空!")
          return false
        }
        params.name = value;
        this.$emit('sendWebsocket', command,params)
      })
    },
    deleteArea(data) {
      this.$confirm('是否确认删除' + data.name, {
        cancelButtonText: '取消',
        confirmButtonText: '确定',
        callback: action => {
          if (action === 'confirm') {
            this.$emit('sendWebsocket', 'delArea',data)
          }
        }
      })
    },
    deleteSection(node,data) {
      if (data.children && data.children.length > 0){
        this.$message.error(data.name + "有子级部门,不能删除!")
        return false
      }
      this.$confirm('是否确认删除' + data.name, {
        cancelButtonText: '取消',
        confirmButtonText: '确定',
        callback: action => {
          if (action === 'confirm') {
            this.$emit('sendWebsocket', 'delSection',data)
          }
        }
      })
    },
    getTree(tree) {
      let result = []
      if(!Array.isArray(tree)) {
        return result
      }
      tree.forEach(item => {
        delete item.children;
      });
      let map = {};
      tree.forEach(item => {
        map[item.id] = item;
      });
      tree.forEach(item =>{
        let parent = map[item.parent];
        if(parent) {
          (parent.children || (parent.children = [])).push(item);
        } else {
          result.push(item);
        }
      })
      return result
    }
  }
}
</script>

<style scoped>
::v-deep .el-tree{
  background: transparent;
}
</style>
